<div
  class="filters"
  matTooltip="Filters cannot be applied within a sub-folder"
  [matTooltipDisabled]="!shouldDisableForm"
  [matTooltipPosition]="'above'">
  <mat-form-field>
    <mat-label>Company name</mat-label>
    <mat-select [formControl]="companyControl" multiple>
      @for (company of companies; track company.id) {
        <mat-option [value]="company.id">{{ company.name }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <button mat-stroked-button class="filters__filter" (click)="filter()" [disabled]="shouldDisableForm">
    Filter
    <mat-icon>filter_alt</mat-icon>
  </button>

  <button
    mat-icon-button
    class="filters__clear"
    (click)="clear()"
    [disabled]="shouldDisableForm || !(companyId | fieldHasValue)">
    <mat-icon>filter_alt_off</mat-icon>
  </button>
</div>
